import logoImage from '../images/logo4.png';
import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import {Link, useLocation } from "react-router-dom";
function NavBar(props) {
  const agent_code = process.env.REACT_APP_SEAMLESS_CODE;
  const agent_token = process.env.REACT_APP_SEAMLESS_TOKEN;
  //const agent_code = process.env.REACT_APP_TRANSFER_CODE;
  //const agent_token = process.env.REACT_APP_TRANSFER_TOKEN;

const { state, unreadMessagesCount } = useLocation();
//console.log('At the NAVBAR ',state)
var superAdmin = state.values.email;
var values = state.values;
//console.log('NavBar state.values ',values);
const admin = process.env.REACT_APP_SUPERADMIN;
//console.log('superAdmin ',superAdmin)
if(superAdmin===admin) { superAdmin = true; } else { superAdmin = false; }
 return (
  <React.StrictMode>
{!superAdmin ? (
<div class="form-control d-grid gap-1 col-10 mx-auto align-items-top">
{/* NOT A superAdmin section*/}
<div className="form-control">
<img src={logoImage} alt="Company logo" className="img-fluid w-10 h-9.35"/>
</div>

<Link to="/home"  state={ state } className="btn btn-success small-button" data-mdb-ripple-init>Home</Link>
<Link to="/agents" state={ state } className="btn btn-success small-button" data-mdb-ripple-init>Agents</Link>
<Link to="/users" state={ state } className="btn btn-success small-button" data-mdb-ripple-init>Users</Link>
<Link to="/transactions" state={ state } className="btn btn-success small-button" data-mdb-ripple-init>Transactions</Link>
<Link to="/signupuser"  state={ state } className="btn btn-success small-button" data-mdb-ripple-init>Create user</Link>
<Link to="/message"  state={ state } className="btn btn-success small-button" data-mdb-ripple-init>Message{unreadMessagesCount > 0 && <span className="orange-spot"></span>}</Link>
<Link to="/pay"  state={ state } className="btn btn-success small-button" data-mdb-ripple-init>Billing</Link>
<Link to="/support"  state={ state } className="btn btn-success small-button" data-mdb-ripple-init>Help</Link>
<a
  href={
    process.env.REACT_APP_BACKEND_URL +
    '/apidocsjili-dynamic?' +
    Object.entries(state.values)
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join('&')
  }
  target="_blank"
  rel="noopener noreferrer"
  className="btn btn-success small-button"
  style={{ marginTop: '4px' }}
>
  API JILI
</a>

<a href={process.env.REACT_APP_BACKEND_URL + '/apidocs12-dynamic?' + new URLSearchParams(Object.entries(state.values)).toString()} 
target="_blank"
rel="noopener noreferrer"
style={{ marginTop: '4px' }}
className="btn btn-success small-button">API 12</a>

<Link to="/"  state={ state } className="btn btn-danger small-button" data-mdb-ripple-init>Logout</Link>
</div>
) : (
<div class="form-control d-grid gap-1 col-10 mx-auto align-items-top">
{/* superAdmin section*/}
<div className="form-control">
<img src={logoImage} alt="Company logo" className="img-fluid w-15 h-9.35"/>
</div>

<Link to="/home"  state={ state } className="btn btn-success small-button" data-mdb-ripple-init>Home</Link>
<Link to="/agents" state={ state } className="btn btn-success small-button" data-mdb-ripple-init>Agents</Link>
<Link to="/users" state={ state } className="btn btn-success small-button" data-mdb-ripple-init>Users</Link>
<Link to="/transactions" state={ state } className="btn btn-success small-button" data-mdb-ripple-init>Transactions</Link>
<Link to="/signupuser"  state={ state } className="btn btn-success small-button" data-mdb-ripple-init>Create user</Link>
<Link to="/signupagent"  state={ state } className="btn btn-success small-button" data-mdb-ripple-init>Create agent</Link>
<Link to="/message"  state={ state } className="btn btn-success small-button" data-mdb-ripple-init>Message{unreadMessagesCount > 0 && <span className="orange-spot"></span>}</Link>
<Link to="/pay"  state={ state } className="btn btn-success small-button" data-mdb-ripple-init>Billing</Link>
<Link to="/support"  state={ state } className="btn btn-success small-button" data-mdb-ripple-init>Help</Link>
<a
  href={
    process.env.REACT_APP_BACKEND_URL +
    '/apidocsjili-dynamic?' +
    Object.entries(state.values)
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join('&')
  }
  target="_blank"
  rel="noopener noreferrer"
  className="btn btn-success small-button"
  style={{ marginTop: '4px' }}
>
  API JILI
</a>

<a href={process.env.REACT_APP_BACKEND_URL + '/apidocs12-dynamic?' + new URLSearchParams(Object.entries(state.values)).toString()} 
target="_blank"
rel="noopener noreferrer"
style={{ marginTop: '4px' }}
className="btn btn-success small-button">API 12</a>

<Link to="/"  state={ state } className="btn btn-danger small-button" data-mdb-ripple-init>Logout</Link>
</div>
)}
  </React.StrictMode>
      )
  
}
export default NavBar;
